module.exports = __webpack_public_path__ + "img/chevron-down.6bcaeb1b.svg";